import React from 'react'
import NotFound from '../notfound'

const NotFoundNo = () => {
    return <NotFound languageCode="no" />
}

export default NotFoundNo
